module.exports = __webpack_public_path__ + "img/default-nav-subnav-honda.98244bc1.png";